<template>
<div>
  <CRUDDialog ref="crudDialog"
:baseCrudKey="baseCrudKey"
 dialogDynamicWidth="600"
    dialogHeaderName="Protest Tax Fund Information" :canSave="true" @upsertItem="upsertFundInfo">
    <template v-slot:[`editedItem`]="{ }">
    <CRUDList
        ref="crudList"
        :canAdd="true"
        :canEdit="false"
        :canSave="true"
        :showSelect="false"
        :showDialog="false"
        :displayTopPagination="false"
        :hideDefaultFooter="true"
        :headers="headers"
        :baseCrudKey="fundBaseCrudKey"
        tableDynamicHeight="200"
        dialogDynamicWidth='600'
        tableWrapperDynamicClassname='taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
        dialogHeaderName="Payment Under Protest"
        :selectedItems="selectedItems"
        @emitSelectedItem="emitSelectedItem"
      > <template v-slot:[`editedItem`]="{}">
          <ProtestTaxFundDialog :baseCrudKey="fundAddCrudKey" />
        </template>
      </CRUDList>
      <v-row class="mt-4 mx-2"  justify="end">
        <v-btn small color="primary" @click="handleDialog">Add New Fund</v-btn>

      </v-row>
      <ProtestTaxFundDialog :baseCrudKey="fundAddCrudKey" />

       <!-- crud dialog for  -->
       <CRUDDialog
        ref="crudDialog"
        :baseCrudKey='paymentDialogCrudKey'
        :canSave="false"
        :dialogHeaderName="dialogHeaderPayment"
       @crudDialogEnter="upsertPayments"
      ><template v-slot:[`editedItem`]="{}">
        <PaymentDialog :baseCrudKey="paymentDialogCrudKey" />
        </template>
           <template v-slot:[`additionalActionsAfterSave`]="{}">
          <UploadFile
                class="mtgtrans uploadFile"
                text
                :bucketName="attachmentConstants.bucketName"
                :program="attachmentConstants.program"
                :parentObjectType="attachmentConstants.parentObjectType"
                :parentObjectId="getActiveTransID || 'n/a'"
                :itemIsSaved="!isNewItem"
              >
                <template v-slot:activator="{ activatorProps }">
                  <v-btn
                    :disabled="enableUploadFile"
                    class="input-text-size"
                    text
                    color="blue darken-1"
                    @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
                    @click="imagesLeftClick(activatorProps.leftClick)"
                  >
                    {{ activatorProps.caption }}
                  </v-btn>
                </template>
              </UploadFile>

        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="onUpsertCall(false)" :disabled="isSaveBlocked">Save</v-btn>
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="onUpsertCall(true)" :disabled="isSaveBlocked">Save & print</v-btn>
        </template>
      </CRUDDialog>
    </template>
  </CRUDDialog>
        <CommonPopUp v-model="showOrHidePopUp"
        :enableFlashTypeMsg="false" :custumWidth="300">
        <template v-slot:customsLabelOrInfo>
        <p style="white-space: pre;">{{ messageText }}</p>
      </template>
        <template v-slot:[`customsButtonsForPopUp`]="{}">
          <v-btn :class="`input-text-size`" text color="blue darken-1"
          @click="openConfirmPopUp('yes')">Yes</v-btn>
          <v-btn :class="`input-text-size`" text color="blue darken-1"
          @click="openConfirmPopUp('no')">No</v-btn>
        </template>
      </CommonPopUp>
</div>

  </template>

<script>
import {
  mapMutations, mapGetters, mapActions, mapState,
} from 'vuex';

import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import { protestTaxFundsHeader } from '../TaxInquiry/TaxInquiryUtils/TableHeaders.utils';
import ProtestTaxFundDialog from '../TaxInquiry/Common/ProtestTaxFundDialog.vue';
import CRUDDialog from '../../common/base/crud-2.0/CRUDDialog.vue';
import {
  getBusinessDateForPaymentEntry,
  toFiscalYear, toShortDate, toTaxYear,
} from '../../../util/shared/tmc-global';
import { getWorkstationNumber } from '../../../util/workstation-util';
import PaymentDialog from '../payments/paymenteditDialog/paymentDialog.vue';
import { amountFormat, amountToNumber, isEmptyObject } from '../../../util/shared/vue-global';
import CommonPopUp from '../common-utils/CommonPopUp.vue';
import PaymentCommonFuncMixin from '../common-utils/PaymentCommonFunc.mixin';
import { TAX_CONSTANTS } from '../common-utils/constants';
import UploadFile from '../../common/UploadFile.vue';

export default {
  name: 'ProtestTaxFundListDialog',
  mixins: [PaymentCommonFuncMixin],
  components: {
    CRUDDialog,
    CRUDList,
    ProtestTaxFundDialog,
    PaymentDialog,
    CommonPopUp,
    UploadFile,

  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      fundBaseCrudKey: 'sharedFund',
      fundAddCrudKey: 'ProtestTaxFundDialog',
      headers: protestTaxFundsHeader,
      fiscalYear: toFiscalYear(new Date()),
      taxYear: toTaxYear(),
      wkstNumber: getWorkstationNumber(),
      paymentDialogCrudKey: 'paymentTransactionList',
      dialogHeaderPayment: 'Payment',
      fromDate: toShortDate(this.todaysDate),
      showOrHidePopUp: false,
      messageText: 'Empty pick list?',
      activeTransItem: undefined,
      attachmentConstants: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      uploadFileParams: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      uploadFileClickParams: {
        leftClickFlag: false,
        leftClickDef: undefined,
        rightClickFlag: false,
        rightClickDef: undefined,
      },
      enableUploadFile: false,
    };
  },

  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'isVisible', 'index']),
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapState({
      StoreSelItems: (state) => state.shared.fund.selectedItems || [],
      nextPaymentNumber: (state) => state.tax.taxPayment.nextPaymentNumber,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
    }),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    editedItem: {
      get() {
        return this.item(this.dialogCrudKey);
      },
      set(value) {
        this.setItem([this.dialogCrudKey, value]);
      },
    },
    isVisibleProp() {
      const visibleFlag = this.isVisible(this.paymentDialogCrudKey);
      if (visibleFlag === undefined) {
        return false;
      }
      return visibleFlag;
    },

    defaultSortBy() {
      return [
        {
          column: 'taxYear',
          direction: 'desc',
        },
      ];
    },
    getActiveTransID() {
      return (this.activeTransItem || {})._id || 'n/a';
      // return this.activeTransItem && this.activeTransItem._id;
    },
    isNewItem() {
      // return !this.editedItem._id;
      return this.index(this.paymentDialogCrudKey) === -1;
    },

  },
  methods: {

    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setIndex']),
    ...mapMutations('shared/fund', [
      'setSelectedItems',
    ]),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapActions('tax/taxPayment', ['upsertTaxPayment',
    ]),

    ...mapActions('tax/taxProtests', ['upsertBulkTaxProtest', 'deleteTaxProtest']),
    ...mapActions('SystemConfig', [
      'getGlobalSettingStore',
    ]),
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async upsertPayments(item) {
      // Enter-key save. Guarded like the buttons: pressing Enter while a save is already
      // running is a second submission and would create a second payment record.
      if (this.isDuplicateSaveClick()) return;
      await this.upsertTransaction(item, false);
    },
    async onUpsertCall(isItFromSaveNPrint) {
      // Ignore a re-click / double-click while the first save is still running - see
      // isDuplicateSaveClick (two no-paymentNumber calls create two payment records).
      if (this.isDuplicateSaveClick()) return;
      const item = this.item(this.paymentDialogCrudKey);
      await this.upsertTransaction(item, false, isItFromSaveNPrint);

      // Close payment dialog first
      this.setIsVisible([this.paymentDialogCrudKey, false]);

      // Wait for parent component to handle upsert success
      this.$emit('upsertFuncCall');

      // Then handle protest transaction and show popup
      await this.handleProtestTransaction(item);
      this.showOrHidePopUp = true;
    },
    deleteFieldsNotRequireToUpsert(item, isDeleteId = false) {
      const updatedItem = { ...item };
      if (isDeleteId) {
        delete updatedItem._id;
      }
      if (Array.isArray(updatedItem.taxDetails)) {
        updatedItem.taxDetails = updatedItem.taxDetails.map((taxDetail) => {
          const { Half, ...rest } = taxDetail;
          return rest;
        });
      }

      delete updatedItem.change;
      delete updatedItem.total;
      delete updatedItem.isVoid;
      delete updatedItem.amount;
      delete updatedItem.penaltyDate;
      delete updatedItem.cashAmount;
      delete updatedItem.checkAmount;
      delete updatedItem.otherAmount;
      delete updatedItem.cashChange;
      return updatedItem;
    },

    // One protest item per tax record on the payment. The server ADDS it to any protest record
    // already there (a second half paid under protest used to replace the first) and works out
    // refund/release from the tax roll, so neither is sent from here.
    async handleProtestTransaction(updatedItem) {
      const fundCrudKey = 'sharedFund';
      const funds = this.item(fundCrudKey);
      const byRecord = {};
      (updatedItem.taxDetails || []).forEach((itemData) => {
        const key = `${itemData.taxYear}-${itemData.taxId}`;
        if (!byRecord[key]) {
          byRecord[key] = {
            itemData, amountPaidUnderProtest: 0, amountPaidNoProtest: 0, hasProtestLine: false,
          };
        }
        const entry = byRecord[key];
        const taxAmt = amountToNumber(itemData.taxAmt);
        if (itemData.protest) {
          entry.itemData = itemData;
          entry.hasProtestLine = true;
          entry.amountPaidUnderProtest = amountToNumber(entry.amountPaidUnderProtest + taxAmt);
        } else {
          entry.amountPaidNoProtest = amountToNumber(entry.amountPaidNoProtest + taxAmt);
        }
      });

      const protestTaxArr = Object.values(byRecord)
        // nothing paid under protest is no protest - it used to leave a $0 record on the list
        .filter((entry) => entry.hasProtestLine && entry.amountPaidUnderProtest !== 0)
        .map(({ itemData, amountPaidUnderProtest, amountPaidNoProtest }) => ({
          taxYear: itemData.taxYear,
          taxId: itemData.taxId,
          fund: (funds || {})._id,
          amountPaidUnderProtest,
          amountPaidNoProtest,
          schoolDistrict: itemData.schoolDistrict,
          needToCheckTax: true,
          totalDue: amountToNumber(itemData.totalDue),
          taxStillDue: amountToNumber(amountToNumber(itemData.totalDue)
            - amountToNumber(itemData.totalPaid)),
          totalPaid: amountToNumber(amountPaidUnderProtest + amountPaidNoProtest),
        }));
      if (!protestTaxArr.length) return;
      const baseCrudKey = 'protestedTax';
      await this.upsertBulkTaxProtest({
        item: protestTaxArr,
        baseCrudKey,
      });
    },
    async getBusinnesDate() {
      const globalSettingVariables = await this.getGlobalSettingStore({});
      const todaysDate = toShortDate();
      let bussDate = todaysDate;
      const bussDateChangeIndividually = this.paymentSettingItem.changeBussDateIndividually;
      if (!bussDateChangeIndividually) {
        bussDate = (globalSettingVariables.configuration || {}).businessDate || todaysDate;
      } else {
        const localBussDate = getBusinessDateForPaymentEntry();
        bussDate = localBussDate || todaysDate;
      }
      return bussDate;
    },
    async populateTaxDetailInPaymentDialog() {
      const pickListRecord = this.items('ProtestTaxPaymentsList');
      const result = [...pickListRecord];

      const bussDate = await this.getBusinnesDate();
      this.setItem([this.paymentDialogCrudKey,
        this.postProcessDataForTaxDetails(result, bussDate)]);
      this.setIsVisible([this.paymentDialogCrudKey, true]);
    },

    async  upsertFundInfo() {
      // store selected data
      const item = this.item(this.fundBaseCrudKey);
      if (!item._id) {
        alert('please select a fund atleast !');
        return;
      }
      this.setItem(['protestFund', item]);
      await this.populateTaxDetailInPaymentDialog();
    },

    postProcessDataForTaxDetails(data, bussDate) {
      const taxDetails = [];
      for (const item of data) {
        const {
          totalDue, taxYear,
        } = item;

        // protest - no line at all when nothing is being paid under protest
        if (amountToNumber(item.amountPaidUnderProtest) !== 0) {
          taxDetails.push({
            // _id: item._id,
            taxYear,
            taxId: item.taxId,
            schoolDistrict: item.schoolDistrict,
            ownerName: `${item.name1 || ''} ${item.name2 || ''}`,
            taxAmt: item.amountPaidUnderProtest,
            originalTaxId: item.taxId,
            // item.totalTax,
            penaltyAmt: item.penalty,
            totalDue,
            itsNewRecord: true,
            total: item.amountPaidUnderProtest,
            protest: true,
            isFromProtestOrPicklist: true, // this will help in warning msg
            isFromOtherSources: true,
            isFromProtest: true, // temporary to know which screen its from
            taxType: 'TAXPAYMENT',
          });
        }
        // non-protest
        taxDetails.push({
          // _id: item._id,
          taxYear: item.taxYear,
          taxId: item.taxId,
          schoolDistrict: item.schoolDistrict,
          ownerName: `${item.name1 || ''} ${item.name2 || ''}`,
          taxAmt: item.amountPaidNoProtest,
          originalTaxId: item.taxId,
          itsNewRecord: true,
          // item.totalTax,
          penaltyAmt: item.penalty,
          totalDue: item.totalDue,
          total: item.amountPaidNoProtest,
          isFromProtestOrPicklist: true, // this will help in warning msg
          isFromOtherSources: true,
          protest: false,
          isFromProtest: true, // temporary to know which screen its from
          taxType: 'TAXPAYMENT',
        });
      }
      const paymentDetails = {
        paidBy: '',
        paymentType: '',
        amount: '0',
      };
      const items = {
        fiscalYear: toFiscalYear(new Date()),
        workstation: Number(this.wkstNumber) || Number(getWorkstationNumber()) || null,
        paymentNumber: this.nextPaymentNumber,
        payDate: toShortDate(bussDate),
        penaltyDate: toShortDate(this.fromDate),
        taxDetails,
        paymentDetails: [paymentDetails],
        total: amountFormat(0),
      };
      return items;
    },
    buildPaymentItem(element) {
      if (element.paymentType) {
        const amount = amountToNumber(element.amount);
        const updatedElement = {
          paymentType: element.paymentType,
          amount,
          paidBy: element.paidBy,
        };
        if (element.paymentType === 'CASH') {
          // updatedElement.cashReceived = amountToNumber(element.cashReceived);
          // updatedElement.cashChange = amountToNumber(element.cashChange);
        }
        if (element.paymentType === 'CREDIT') {
          updatedElement.creditType = element.creditType;
        }
        if (element.paymentType === 'CHECK') {
          updatedElement.checkNumber = element.checkNumber;
          // updatedElement.checkPaidBy = element.checkPaidBy;
        }
        if (element.paymentType === 'EFT') {
          updatedElement.eftType = element.eftType;
        }
        return { ...updatedElement };
      }
      return { ...element };
    },
    openConfirmPopUp(fromWhere) {
      if (fromWhere === 'no') this.showOrHidePopUp = false;
      else if (fromWhere === 'yes') {
        this.showOrHidePopUp = false;
        const baseCrudKey = 'ProtestTaxPaymentsList';
        this.deleteTaxProtest({ baseCrudKey });
      }
    },
    // async handlePayment(item) {
    //   // const { baseCrudKey } = this;
    //   const updatedItem = this.deleteFieldsNotRequireToUpsert(item);
    //   if ((updatedItem.paymentDetails || []).length > 0) {
    //     updatedItem.paymentDetails = updatedItem.paymentDetails.map((element) => {
    //       const newUpdatedElement = this.buildPaymentItem(element);
    //       return {
    //         ...newUpdatedElement,
    //       };
    //     });
    //   }
    //   if ((updatedItem.taxDetails || []).length > 0) {
    //     updatedItem.taxDetails = updatedItem.taxDetails.map((element) => {
    //       const el = element;
    //       el.taxYear = amountToNumber(element.taxYear);
    //       el.taxId = amountToNumber(element.taxId);
    //       el.taxAmt = amountToNumber(el.taxAmt);
    //       el.penaltyAmt = amountToNumber(el.penaltyAmt);
    //       el.total = amountToNumber(el.total);
    //       const taxDetailItem = { ...el };
    //       return {
    //         ...taxDetailItem,
    //       };
    //     });
    //   }
    //   updatedItem.workstation = amountToNumber(updatedItem.workstation);
    //   this.upsertTransaction(updatedItem).then(() => {
    //     this.handleProtestTransaction(updatedItem);
    //     this.showOrHidePopUp = true;
    //   });
    // },

    dataFromCommonDropDowns(val) {
      this.taxYear = val;
    },
    handleDialog() {
      const funds = this.items('sharedFund');
      const updatedItem = {};
      if (funds.length > 0) {
        const fundItem = funds[funds.length - 1];
        updatedItem.fund = (amountToNumber(fundItem.fund, 10) + 1).toString();
      } else {
        updatedItem.fund = amountToNumber(TAX_CONSTANTS.PROTESTFUND.MIN).toString();
      }
      const protestTax = this.items('ProtestTaxPaymentsList');
      const owner = protestTax.length > 0 ? protestTax[0] : '';
      updatedItem.description = `${owner.taxYear} Protest Tax ${owner.name1}`;
      this.setItem([this.fundAddCrudKey, updatedItem]);
      this.setIsVisible([this.fundAddCrudKey, true]);
    },
    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: (this.activeTransItem || {})._id || 'n/a',
      });
    },
    settingFields(res) {
      this.activeTransItem = res;
      this.setItem([this.paymentDialogCrudKey, res]);
      this.setIndex([this.paymentDialogCrudKey, 0]);
    },
    updateActiveTransItem(res) {
      if (this.uploadFileClickParams.leftClickFlag) {
        this.settingFields(res);
        this.$nextTick(() => {
          this.imagesLeftClick(this.uploadFileClickParams.leftClickDef);
          this.uploadFileClickParams.leftClickFlag = false;
          this.uploadFileClickParams.leftClickDef = undefined;
        });
      } else if (this.uploadFileClickParams.rightClickFlag) {
        this.settingFields(res);
        this.$nextTick(() => {
          this.imagesRightClick(this.uploadFileClickParams.rightClickDef);
          this.uploadFileClickParams.rightClickFlag = false;
          this.uploadFileClickParams.rightClickDef = undefined;
        });
      }
      return false;
    },
    // Removed redundant upsrtTransaction method as it was causing issues
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        // this.selectedItems = [];
      });
    },
    async preUpsertTransaction(item, avoidUpdatingCrudList, isItFromSaveNPrint, shouldCloseDialog) {
      // if (this.isValidFormProp(this.baseCrudKey).value) {
      this.enableUploadFile = true;
      // eslint-disable-next-line max-len
      const response = await this.upsertTransaction(item, avoidUpdatingCrudList, isItFromSaveNPrint, shouldCloseDialog);
      // this.getPickLists(); // to reload the pick list table
      this.enableUploadFile = false;
      if (!isEmptyObject(response)) {
        this.updateActiveTransItem(response);
      }
      this.setDefaultSelectedItems();
      // this.callTheBroadBand();
      // return response;
      // }
      // return [];
    },
    async imagesLeftClick(leftClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.leftClickFlag = true;
        this.uploadFileClickParams.leftClickDef = leftClick;
        // await this.upsrtTransaction(this.editedItem, false);
        await this.preUpsertTransaction(this.item(this.paymentDialogCrudKey), true, false, false);
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.rightClickFlag = true;
        this.uploadFileClickParams.rightClickDef = rightClick;
        // this.setIsVisible([this.paymentDialogCrudKey, true]);
        await this.preUpsertTransaction(this.item(this.paymentDialogCrudKey), true, false, false);
        // this.setIsVisible([this.paymentDialogCrudKey, true]);
        rightClick();
      }
    },

  },
  watch: {
    isVisibleProp(newVal) {
      if (newVal) {
        this.$nextTick(() => { this.loadFiles(); });
      } else {
        // this.activeTransItem = undefined;
      }
    },
  },
};
</script>
